var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "capture-record-list" },
    [
      _vm.hasUnplacedItems
        ? _c(
            "v-alert",
            {
              staticClass: "mx-3 mb-0 text-caption",
              attrs: { dense: "", type: "info", text: "" },
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("dragHint")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasAnyItems
        ? _c(
            "div",
            {
              staticClass: "capture-record-list__empty",
              attrs: { "data-testid": "capture-record-empty" },
            },
            [
              _c("v-icon", { attrs: { large: "", color: "grey lighten-1" } }, [
                _vm._v("inventory_2"),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("emptyMessage")))]),
            ],
            1
          )
        : _c(
            "ul",
            { staticClass: "capture-record-list__items" },
            [
              _vm._l(_vm.placeableItems, function (item) {
                return _c(
                  "li",
                  {
                    key: item.id,
                    class: _vm.itemClasses(item),
                    attrs: {
                      draggable: _vm.isDraggable(item),
                      "data-testid": "capture-item",
                    },
                    on: {
                      dragstart: function ($event) {
                        return _vm.handleDragStart($event, item)
                      },
                    },
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          small: "",
                          color: _vm.getIconColor(item),
                          "data-testid": "capture-status",
                        },
                      },
                      [_vm._v(_vm._s(_vm.getIcon(item)))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "capture-record-list__body" }, [
                      _c("div", { staticClass: "capture-record-list__head" }, [
                        _c(
                          "span",
                          { staticClass: "capture-record-list__title" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.speciesLabel(item.species)) +
                                " " +
                                _vm._s(item.count) +
                                _vm._s(_vm.$t("countUnit")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      item.isPlacedOnOtherFloorPlan
                        ? _c(
                            "div",
                            { staticClass: "capture-record-list__placed-on" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("placedOnOther", {
                                      name: item.placedFloorPlanName,
                                    })
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "capture-record-list__tags" },
                        _vm._l(item.sensorEntries, function (entry) {
                          return _c(
                            "span",
                            {
                              key: entry.id,
                              staticClass: "capture-record-list__tag",
                            },
                            [_vm._v(_vm._s(entry.name))]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      item.memo
                        ? _c(
                            "div",
                            {
                              staticClass: "capture-record-list__memo",
                              attrs: { "data-testid": "capture-memo" },
                            },
                            [_vm._v(_vm._s(item.memo))]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "capture-record-list__more" },
                      [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "offset-y": "",
                              left: "",
                              "content-class": "capture-record-menu",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: {
                                              icon: "",
                                              "x-small": "",
                                              "data-testid": "capture-more",
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("more_vert")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              [
                                item.isPlaced
                                  ? _c(
                                      "v-list-item",
                                      {
                                        attrs: {
                                          "data-testid": "capture-menu-unplace",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "unplace",
                                              item.record
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-icon",
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-pin-off")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(_vm.$t("unplace"))),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-list-item",
                                  {
                                    attrs: {
                                      "data-testid": "capture-menu-edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("edit", item.record)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("edit"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(_vm.$t("edit"))),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-item",
                                  {
                                    attrs: {
                                      "data-testid": "capture-menu-delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDeleteConfirm(
                                          item.record
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              small: "",
                                              color: "error",
                                            },
                                          },
                                          [_vm._v("delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "error--text" },
                                      [_vm._v(_vm._s(_vm.$t("delete")))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.otherFloorPlanItems.length > 0
                ? [
                    _c(
                      "li",
                      { staticClass: "capture-record-list__divider" },
                      [
                        _c("list-section-divider", {
                          attrs: {
                            label: _vm.$t("otherFloorPlanSection"),
                            testid: "other-floor-plan-section-header",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.otherFloorPlanItems, function (item) {
                      return _c(
                        "li",
                        {
                          key: item.id,
                          class: _vm.itemClasses(item),
                          attrs: {
                            draggable: false,
                            "data-testid": "capture-item",
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                color: _vm.getIconColor(item),
                                "data-testid": "capture-status",
                              },
                            },
                            [_vm._v(_vm._s(_vm.getIcon(item)))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "capture-record-list__body" },
                            [
                              _c(
                                "div",
                                { staticClass: "capture-record-list__head" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "capture-record-list__title",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.speciesLabel(item.species)
                                          ) +
                                          " " +
                                          _vm._s(item.count) +
                                          _vm._s(_vm.$t("countUnit")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              item.isPlacedOnOtherFloorPlan
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "capture-record-list__placed-on",
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t("placedOnOther", {
                                              name: item.placedFloorPlanName,
                                            })
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "capture-record-list__tags" },
                                _vm._l(item.sensorEntries, function (entry) {
                                  return _c(
                                    "span",
                                    {
                                      key: entry.id,
                                      staticClass: "capture-record-list__tag",
                                    },
                                    [_vm._v(_vm._s(entry.name))]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              item.memo
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "capture-record-list__memo",
                                      attrs: { "data-testid": "capture-memo" },
                                    },
                                    [_vm._v(_vm._s(item.memo))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "capture-record-list__more" },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "offset-y": "",
                                    left: "",
                                    "content-class": "capture-record-menu",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    "x-small": "",
                                                    "data-testid":
                                                      "capture-more",
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { small: "" } },
                                                  [_vm._v("more_vert")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    [
                                      item.isPlaced
                                        ? _c(
                                            "v-list-item",
                                            {
                                              attrs: {
                                                "data-testid":
                                                  "capture-menu-unplace",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$emit(
                                                    "unplace",
                                                    item.record
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list-item-icon",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [_vm._v("mdi-pin-off")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("unplace"))
                                                ),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item",
                                        {
                                          attrs: {
                                            "data-testid": "capture-menu-edit",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "edit",
                                                item.record
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("edit")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(_vm.$t("edit"))),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item",
                                        {
                                          attrs: {
                                            "data-testid":
                                              "capture-menu-delete",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDeleteConfirm(
                                                item.record
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "error",
                                                  },
                                                },
                                                [_vm._v("delete")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "error--text" },
                                            [_vm._v(_vm._s(_vm.$t("delete")))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
      _vm._v(" "),
      _c("confirm-dialog", {
        attrs: { message: _vm.$t("confirm.delete_capture_record") },
        on: { yes: _vm.handleConfirmYes },
        model: {
          value: _vm.confirm.visible,
          callback: function ($$v) {
            _vm.$set(_vm.confirm, "visible", $$v)
          },
          expression: "confirm.visible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }